import axios, { AxiosPromise } from 'axios';

import { ICarrier } from '../../../@types/model/masterData/carrier/carrier';
import { ICarrierUpsert } from '../../../@types/model/masterData/carrier/carrierUpsert';

export default class CarrierHttpService {
    public static getCarrierData() : AxiosPromise<Array<ICarrier>> {
        return axios.get(`${API_URL}/v1/Carrier/GetAllWeb`);
    }

    public static addOrUpdateCarrier(upsert : ICarrierUpsert) : AxiosPromise<ICarrier> {
        return axios.post(`${API_URL}/v1/Carrier/PostCarrier`, upsert);
    }

    public static deleteCarrier(carrierId : number) : AxiosPromise<ICarrier> {
        return axios.delete(`${API_URL}/v1/Carrier/Delete`, {
            params : { carrierId },
        });
    }
}
